import { AbstractJSONModel } from "./master-model";

export interface IDepartmentEmployee {
  id: number;
  department_id: number;
  employee_id: number;
  primary_department: boolean;
}

export class DepartmentEmployee extends AbstractJSONModel implements IDepartmentEmployee {
  public id = -1;
  public department_id = -1;
  public employee_id = -1;
  public primary_department = false;

  equals(other: IDepartmentEmployee): boolean {
    return other.id === this.id;
  }
}
